var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0A12.002 12.002 0 000 12a12.003 12.003 0 0012 12 12.003 12.003 0 0012-12A12.003 12.003 0 0012 0zm-.164 19.895a1.373 1.373 0 11.001-2.746 1.373 1.373 0 010 2.746zm1.501-6.67s-.135.05-.135.128v1.09a1.368 1.368 0 01-2.734 0v-1.09a2.89 2.89 0 011.994-2.72 1.94 1.94 0 001.325-1.903 1.994 1.994 0 00-1.964-1.89 1.937 1.937 0 00-1.738 1.103 1.367 1.367 0 11-2.463-1.187 4.652 4.652 0 014.179-2.65h.027a4.721 4.721 0 014.689 4.542 4.66 4.66 0 01-3.177 4.575l-.003.003z",
    fill: "#00264F",
    fillRule: "nonzero"
  })));
}

export default SvgQuestion;